import { AxiosError } from 'axios';
import { eventsRequest } from '../../utils/eventsRequest';
import { ErrorResponse } from '../../types';

const addCoupon = async (couponId: any) => {
    let arrayResponse = {
        success: false,
        message: 'Failed to add coupon.',
    };

    try {
        const response = await eventsRequest(`/cart/coupon/${couponId}`, 'post');

        if (response.status === 200 || response.status === 201) {
            arrayResponse.success = true;
            arrayResponse.message = 'Coupon added.';
        }
        return arrayResponse;
    } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response && axiosError.response.status === 400) {
            arrayResponse.message = axiosError.response.data.message;
        }
        return arrayResponse;
    }
};

export default addCoupon;
